import type { RouteRecordRaw } from 'vue-router';

const publicRoutes: RouteRecordRaw = {
  path: '/',
  meta: {
    guest: true,
  },
  children: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/views/pages/Landing.vue'),
    },
    {
      path: '/pages/notfound',
      name: 'notfound',
      component: () => import('@/views/pages/NotFound.vue'),
      meta: { hybrid: true },
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('@/views/pages/auth/Login.vue'),
    },
    {
      path: '/auth/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/pages/auth/ForgotPassword.vue'),
    },
    {
      path: '/auth/reset-password',
      name: 'reset-password',
      component: () => import('@/views/pages/auth/ResetPassword.vue'),
    },
    {
      path: '/auth/register',
      name: 'register',
      component: () => import('@/views/pages/auth/Register.vue'),
    },
    {
      path: '/auth/create-organization',
      name: 'create-organization',
      component: () => import('@/views/pages/auth/CreateOrganization.vue'),
    },

    {
      path: '/auth/:provider/callback',
      name: 'validate-token',
      component: () => import('@/views/pages/auth/ValidateToken.vue'),
    },

    {
      path: '/auth/access',
      name: 'accessDenied',
      component: () => import('@/views/pages/auth/Access.vue'),
    },
    {
      path: '/auth/error',
      name: 'error',
      component: () => import('@/views/pages/auth/Error.vue'),
    },
    {
      path: '/auth/deactivated',
      name: 'deactivated',
      component: () => import('@/views/pages/auth/Deactivated.vue'),
      meta: { hybrid: true },
    },
  ],
};

export default publicRoutes;
